// react
import { useEffect, useRef } from 'react';

// styles
import { StyledDojoHost } from './DojoTabContent.styles';

// types
import type { DojoTabContentProps } from './DojoTabContent.types';

/**
 * Hosts a legacy dojo widget. TabPanel only renders its children while the tab is active,
 * so mounting and unmounting this component is the render/destroy signal for dojo — no
 * callback prop on TabPanel needed.
 */
const DojoTabContent = ({ renderId, destroyId }: DojoTabContentProps) => {
  'use memo';

  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    // Dojo takes ownership of (and on destroy removes) the node it is handed, so give it a
    // throwaway child instead of the React-owned host element.
    const container = document.createElement('div');
    host.appendChild(container);

    // The bridge is optional (see `dojoTopic` in types.d.ts): react-app also runs without
    // the dojo shell, and then there is nothing to publish to.
    window.dojoTopic?.publish(renderId, container);

    return () => window.dojoTopic?.publish(destroyId);
  }, [destroyId, renderId]);

  return <StyledDojoHost ref={hostRef} />;
};

export default DojoTabContent;
